
import { Options, Vue } from "vue-class-component";
import { store } from "@/store";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import {
  dispatchCreateAccount,
  dispatchDeleteAccount,
  dispatchGetAccounts,
  dispatchUpdateAccount,
} from "@/store/task/actions";
import { readAccountList } from "@/store/task/getters";
import { compare, dateConversion, getLocalProject } from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import { readMyProjects } from "@/store/project/getters";

@Options({
  components: {
    SideMenu,
  },
})
export default class AccountManage extends Vue {
  public accountForm = {
    account: "",
    password: "",
    remark: "",
    type: "",
    project: "",
  };
  public accountOptions = [
    { label: "QQ", value: 0 },
    { label: "Wechat", value: 1 },
    { label: "Other", value: 2 },
  ];
  public AccountFields = [
    { label: "更新者", prop: "update_user" },
    { label: "更新时间", prop: "update_date" },
  ];
  public search = "";
  public loading = false;
  public dialogVisible = false;
  public project = Number(getLocalProject());
  public newAccount = {
    account: "",
    password: "",
    type: "",
    remark: "",
  };

  public async mounted() {
    this.loading = true;
    await dispatchGetAccounts(store, { project: this.project });
    this.loading = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.project
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  handleEdit(row: any, accountForm: any) {
    if (!row.isEdit) {
      row.isEdit = !row.isEdit;
      row.handleEditText = "取消";
      row.info = "info";
      row.isDanger = "primary";
      row.handleDeleteText = "提交";
      row.handleConfirmText = "确认更改账号?";
    } else {
      row.isEdit = !row.isEdit;
      row.isDanger = "danger";
      row.info = "warning";
      row.handleEditText = "编辑";
      row.handleDeleteText = "删除";
      row.handleConfirmText = "确认删除账号?";
    }
  }
  //编辑, 删除
  handleDeleteAccount(row: any, accountForm: any) {
    if (row.handleDeleteText === "提交") {
      // todo: 以更好的方式获取input selece value
      const commitForm: any = {};
      commitForm.project = row.project;
      commitForm.type = (document.getElementById(
        "type" + row.account_id
      ) as any).value;
      commitForm.account = (document.getElementById(
        "account" + row.account_id
      ) as any).value;
      const password = (document.getElementById(
        "password" + row.account_id
      ) as any).value;
      commitForm.remark = (document.getElementById(
        "remark" + row.account_id
      ) as any).value;

      if (commitForm.account === "") {
        alert("账号名称不能为空");
        return;
      }
      // 账号需要支持邮箱, 需要修改正则
      // if (!regChineseObJ.test(commitForm.account)) {
      //   alert_re_chinese("账号");
      //   return;
      // }
      // if (!regEnglishObj.test(password) && password !== "") {
      //   alert_re_english("密码");
      //   return;
      // }
      // if (!regChineseObJ.test(commitForm.remark)) {
      //   alert_re_chinese("备注");
      //   return;
      // }
      if (password === "") {
        delete commitForm.password;
      }

      // commitForm.password = Md5.hashStr(password).toString();
      commitForm.password = password;
      dispatchUpdateAccount(store, {
        id: row.account_id,
        account: commitForm,
      });
    } else {
      dispatchDeleteAccount(store, {
        id: row.account_id,
        project: row.project,
      });
    }
  }

  getAccounts(search: string) {
    const account_list: any[] = readAccountList(store);
    for (let account of account_list) {
      if (account.type === 0) {
        account.type_str = "QQ";
      } else if (account.type === 1) {
        account.type_str = "Wechat";
      } else {
        account.type_str = "Other";
      }
      account.update_timestamp = new Date(account.update_time).getTime();
      account.update_date = dateConversion(account.update_time);
      account.isEdit = false;
      account.handleEditText = "编辑";
      account.handleDeleteText = "删除";
      account.handleConfirmText = "确定删除账号？";
      account.isDanger = "danger";
      account.info = "warning";
    }
    return account_list
      .filter(
        (data) =>
          !search ||
          data.account?.toLowerCase().includes(search.toLowerCase()) ||
          data.type_str?.toLowerCase().includes(search.toLowerCase())
      )
      .sort(compare("update_timestamp"));
  }

  public async submitForm() {
    let FormVal = {
      account: this.newAccount.account,
      password: this.newAccount.password,
      type: Number(this.newAccount.type),
      remark: this.newAccount.remark,
      project: this.project,
    };
    await dispatchCreateAccount(store, FormVal);
    await dispatchGetAccounts(store, { project: this.project });
    this.dialogVisible = false;
  }
}
